import { log, supabase } from ".";

/**
 * Empresas VIP de un país, ya normalizadas (empresa_norm — trim/mayúsculas/sin tildes, misma
 * normalización que `empresaContacto.normalizarEmpresa`). Tabla chica de excepción — ver migración
 * 20260923c_crear_empresas_vip.sql.
 * @param {string} pais
 * @returns {Promise<Set<string>>}
 */
export const getEmpresasVip = async (pais) => {
  try {
    const data = await supabase.select("empresas_vip", { filters: { pais } });
    return new Set((data || []).map((r) => r.empresa_norm));
  } catch (error) {
    log.error("getEmpresasVip", error);
    return new Set();
  }
};
